import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgUploaderModule } from 'ngx-uploader';

import {
  BaThemeConfig
} from './theme.config';

import {
  BaThemeConfigProvider
} from './theme.configProvider';

import {
  BaBackTop,
  BaCard,
  BaCheckbox,
  BaContentTop,
  BaMenuItem,
  BaMenu,
  BaMsgCenterComponent,
  BaMultiCheckbox,
  BaPageTopComponent,
  BaPictureUploader,
  BaSidebar
} from './components';
import { ClockComponent } from './components/clock/clock.component';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { HappyBirthdayComponent } from './components/happy-birthday/happy-birthday.component';
import { PopUpComponent } from './components/pop-up/pop-up.component';

import { BaCardBlur } from './components/baCard/baCardBlur.directive';

import {
  BaScrollPosition,
  BaSlimScroll,
  BaThemeRun
} from './directives';

import {
  BaAppPicturePipe,
  BaKameleonPicturePipe,
  BaProfilePicturePipe
} from './pipes';

import {
  BaImageLoaderService,
  BaMenuService,
  BaThemePreloader,
  BaThemeSpinner
} from './services';

import {
  EmailValidator,
  EqualPasswordsValidator
} from './validators';

import { HttpModule, Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig  } from 'angular2-jwt';
export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp( new AuthConfig({}), http, options);
}
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import {
  GrowlModule,
  MessageModule,
  MessagesModule,
  DialogModule,
  ButtonModule,
  EditorModule,
} from 'primeng/primeng';

import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsService } from './services/notifications/notifications.service';
import { CapitalizePipe } from './pipes/capitalize.pipe';

export function createTranslateLoader(http: Http) {
  return new TranslatePoHttpLoader(http, '/assets/i18n/', '.po');
}

const NGA_COMPONENTS = [
  BaBackTop,
  BaCard,
  BaCheckbox,
  BaContentTop,
  BaMenuItem,
  BaMenu,
  BaMsgCenterComponent,
  BaMultiCheckbox,
  BaPageTopComponent,
  BaPictureUploader,
  BaSidebar,
  ClockComponent,
  CalculatorComponent,
  HappyBirthdayComponent,
  PopUpComponent
];

const NGA_DIRECTIVES = [
  BaScrollPosition,
  BaSlimScroll,
  BaThemeRun,
  BaCardBlur
];

const NGA_PIPES = [
  BaAppPicturePipe,
  BaKameleonPicturePipe,
  BaProfilePicturePipe
];

const NGA_SERVICES = [
  BaImageLoaderService,
  BaThemePreloader,
  BaThemeSpinner,
  BaMenuService,
  NotificationsService
];

const NGA_VALIDATORS = [
  EmailValidator,
  EqualPasswordsValidator
];

@NgModule({
  declarations: [
    ...NGA_PIPES,
    ...NGA_DIRECTIVES,
    ...NGA_COMPONENTS,
    NotificationsComponent,
    CapitalizePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgUploaderModule,
    GrowlModule,
    MessageModule,
    MessagesModule,
    DialogModule,
    ButtonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http]
      }
    }),
  ],
  exports: [
    ...NGA_PIPES,
    ...NGA_DIRECTIVES,
    ...NGA_COMPONENTS
  ]
})
export class NgaModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders> {
      ngModule: NgaModule,
      providers: [
        BaThemeConfigProvider,
        BaThemeConfig,
        ...NGA_VALIDATORS,
        ...NGA_SERVICES
      ],
    };
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/nga.module.ts